import { useToken, useColorMode } from '@chakra-ui/react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { getContrastColors } from '../theme/teamColors';

const StackedBarChart = ({ ballData, homeTeam, awayTeam }) => {
  const { colorMode } = useColorMode();
  const { home: homeColor, away: awayColor } = getContrastColors(homeTeam, awayTeam, colorMode === 'dark');
  const [gridColor, labelColor, tooltipBg, tooltipText] = useToken('colors', [
    'chart.grid',
    'chart.label',
    'brand.charcoal',
    'white'
  ]);

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={ballData}
        margin={{
          top: 10,
          right: 15,
          left: 5,
          bottom: 25,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke={gridColor} />
        <XAxis
          dataKey="inning"
          interval={0}
          label={{
            value: 'Inning', 
            position: 'insideBottom', 
            offset: -15, 
            fontSize: '10px',
            fontWeight: '900',
            fill: labelColor,
            fontFamily: "'HEX Franklin MLB', sans-serif"
          }} 
          tick={{ fontSize: '11px', fill: labelColor, fontWeight: 'bold' }}
          stroke={gridColor}
        />
        <YAxis
          allowDecimals={false}
          label={{
            value: 'Balls', 
            angle: -90, 
            position: 'insideLeft', 
            offset: 10,
            fontSize: '10px',
            fontWeight: '900',
            fill: labelColor,
            fontFamily: "'HEX Franklin MLB', sans-serif"
          }} 
          tick={{ fontSize: '11px', fill: labelColor, fontWeight: 'bold' }}
          stroke={gridColor}
        />
        <Tooltip
          cursor={{ fill: colorMode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.05)' }}
          contentStyle={{ 
            backgroundColor: tooltipBg, 
            borderColor: gridColor, 
            borderRadius: '0px',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.4)',
            fontSize: '12px',
            fontWeight: '900',
            color: tooltipText,
            border: '1px solid'
          }}
          itemStyle={{ color: tooltipText }}
        />
        <Bar dataKey={homeTeam} stackId="a" fill={homeColor} name={homeTeam} radius={[0, 0, 0, 0]} isAnimationActive={false} />
        <Bar dataKey={awayTeam} stackId="a" fill={awayColor} name={awayTeam} radius={[2, 2, 0, 0]} isAnimationActive={false} />
      </BarChart>
    </ResponsiveContainer>
  );
};
export default StackedBarChart;
